import React from "react";
import { sectionsTexts } from "../../props/sectionsTexts";
import { SectionHeading } from "../../components/sectionHeading";
import { RedWords } from "../../components/redWords";
import { Link } from "../../components/links";
import { TagsPreCode } from "../../components/preCode";

export class SetConversionTags extends React.Component {
    render() {
        return (
            <div className="section__wrapper">
                <section className="section section__not-homepage" id="setConversionTags">
                    <SectionHeading prop={sectionsTexts.setConversionTags} />
                    <div className="section__content">
                        <p className="section__lead">
                            <RedWords prop={'Конверсионный тег'} /> — это специальный код (скрипт <b>&lt;script&gt;</b>  или пиксель <b>&lt;img&gt;</b>), который размещается на сайте для отслеживания совершения целевых действий пользователями. Такие действия называются конверсиями — например, покупка, оформление заявки, регистрация или достижение определённого шага в воронке продаж.
                            <br />
                            Когда пользователь выполняет нужное действие, тег срабатывает и передаёт информацию в нашу систему WCM.
                            <br />
                            При получении брифа от менеджера WCM с конверсионными тегами для установки на сайт обязательно уточните тип тегов, которые необходимо внедрить.
                            <br />
                            В системе различаются два типа тегов:
                            <ol className="section__list">
                                <li className="section__list-item">
                                    <Link prop={{ text: "Стандартный тег (Standard counter tag)", href: "#anchor1" }} />
                                    <br />
                                    Фиксирует сам факт совершения конверсии (например, нажатие на кнопку, отправка формы, регистрация и т.д.). Не передаёт дополнительных данных.
                                </li>
                                <li className="section__list-item">
                                    <Link prop={{ text: "Расширенный тег (Advanced / Sales conversion tag)", href: "#anchor2" }} />
                                    <br />
                                    Помимо фиксации события, передаёт дополнительные параметры, такие как:
                                    <ul className="section__list">
                                        <li className="section__list-item">
                                            ID заказа
                                        </li>
                                        <li className="section__list-item">
                                            стоимость покупки
                                        </li>
                                        <li className="section__list-item">
                                            тип товара/услуги
                                        </li>
                                        <li className="section__list-item" id="anchor1"> {/* Якорь здесь, из-за fixed хедера */}
                                            и другие пользовательские параметры, указанные в брифе
                                        </li>
                                    </ul>
                                </li>
                            </ol>
                        </p>
                    </div>
                    <div className="section__content">
                        <div className="section__lead">
                            <h3>СТАНДАРТНЫЙ КОНВЕРСИОННЫЙ ТЕГ</h3>
                            <RedWords prop={'Стандартный конверсионный тег'} /> — предназначен для подсчёта количества целевых действий, совершённых пользователями на определённой странице сайта после просмотра или клика по рекламному объявлению.
                            <br />
                            При получении брифа от менеджера WCM с конверсионными тегами для установки на сайт обязательно уточните тип тегов, которые необходимо внедрить.
                            <br /><br />
                            <b>Пример стандартного конверсионного тега &lt;img&gt;:</b>
                            <br /><br />
                            <div class="somecode">
								<div class="code">
									<div class="code_wrapper">
                                        <div class="line">
                                            <pre>{TagsPreCode.standardImg}</pre>
                                        </div>
									</div>
								</div>
							</div>
                            <br />
                            <b>Пример стандартного конверсионного тега &lt;script&gt;:</b>
                            <br /><br />
                            <div class="somecode">
								<div class="code">
									<div class="code_wrapper">
                                        <div class="line">
                                            <pre>{TagsPreCode.standardScript}</pre>
                                        </div>
									</div>
								</div>
							</div>
                            <br />
                            Где в обоих примерах *<b>WCM_ID</b>* и *<b>ID</b>* - актуальны в брифе, полученном от менеджера WCM.
                            <br id="anchor2"/> {/* Якорь здесь, из-за fixed хедера */}
                        </div>
                    </div>
                    <br />
                    <div className="section__content">
                        <div className="section__lead">
                            <h3>РАСШИРЕННЫЙ КОНВЕРСИОННЫЙ ТЕГ</h3>
                            <RedWords prop={'Расширенный конверсионный тег со сбором параметров'} /> используется для фиксации целевых действий пользователей, а также для передачи дополнительных параметров, связанных с конверсией — таких как стоимость покупки, ID заказа, валюта, тип события и другие данные, указанные в брифе.
                            <br /><br />
                            <b>Пример расширенного конверсионного тега &lt;img&gt;:</b>
                            <br /><br />
                            <div class="somecode">
								<div class="code">
									<div class="code_wrapper">
                                        <div class="line">
                                            <pre>{TagsPreCode.advancedImg}</pre>
                                        </div>
									</div>
								</div>
							</div>
                            <br />
                            <b>Пример расширенного конверсионного тега &lt;script&gt;:</b>
                            <br /><br />
                            <div class="somecode">
								<div class="code">
									<div class="code_wrapper">
										<div class="line">
                                            <pre>{TagsPreCode.advancedScript}</pre>
                                        </div>
									</div>
								</div>
							</div>
                            <br />
                            Где в обоих примерах *<b>WCM_ID</b>* и *<b>ID</b>* - актуальны в брифе, полученном от менеджера WCM.
                            <br />
                        </div>
                    </div>
                    <br />
                    <div className="section__content">
                        <div className="section__lead">
                            <h3>УСТАНОВКА КОНВЕРСИОННЫХ ТЕГОВ</h3>
                            <RedWords prop={'Конверсионный тег'} /> необходимо вызывать при совершении целевого действия на сайте (например, нажатие на кнопку, отправка формы, регистрация и т.д.).
                            <br />
                            Теги можно установить на сайте через <b>вёрстку</b> на целевой странице.
                            <br />
                            <br />
                            <b>Пример установки стандартного конверсионного тега &lt;img&gt; на клик по кнопке:</b>
                            <br /><br />
                            <div class="somecode">
                                <div class="code">
                                    <div class="code_wrapper">
                                        <div class="line">
                                            <pre>{TagsPreCode.setStandardImg}</pre>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            Реализация установки тегов возможна через JavaScript-функции в слушателях addEventListener() и прочие аналогичные удобные вам способы.
                            <br /><br />
                            <b>Пример установки расширенного конверсионного тега &lt;img&gt;:</b>
                            <br /><br />
                            <div class="somecode">
                                <div class="code">
                                    <div class="code_wrapper">
                                        <div class="line">
                                            <pre>{TagsPreCode.setAdvancedImg}</pre>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            Где *<b>WCM_ID</b>* и *<b>ID</b>* - актуальны в брифе, полученном от менеджера WCM. Набор дополнительных параметров необходимо уточнить у менеджера.
                            Для корректной работы расширенного тега необходимо передавать динамические значения параметров из сайта (например, из e-commerce-системы или формы заказа).
                            <br />
                            <h4>Описание параметров расширенного тега:</h4>
                            <table class="tableTagsParams">
                                <thead>
                                    <tr>
                                        <th>Для тега &lt;script&gt;</th>
                                        <th>Для тега &lt;img&gt;</th>
                                        <th>Описание</th>
                                    </tr>
                                </thead>
                                <tr>
                                    <td>client</td>
                                    <td>a.cid</td>
                                    <td>ID клиента</td>
                                </tr>
                                <tr>
                                    <td>amount</td>
                                    <td>a.re</td>
                                    <td>Стоимость покупки/заказа</td>
                                </tr>
                                <tr>
                                    <td>invoice_id</td>
                                    <td>a.iid</td>
                                    <td>ID заказа</td>
                                </tr>
                                <tr>
                                    <td>quantity</td>
                                    <td>a.inu</td>
                                    <td>Количество товаров в заказе</td>
                                </tr>
                                <tr>
                                    <td>is_client</td>
                                    <td>a.is</td>
                                    <td>1 - если Клиент новый, 0 – если не новый</td>
                                </tr>
                                <tr>
                                    <td>optional_parameters</td>
                                    <td>a.opt</td>
                                    <td>Возможность передачи кастомных значений*</td>
                                </tr>
                            </table>
                            <br />
                            <b>*</b>При необходимости можно настроить передачу различных кастомных значений с помощью параметра optional parameters.
                            <br />
                            Каждый расширенный конверсионный тег может содержать необходимые для Ваших целей свободные параметры и передавать по ним соответствующие значения. 
                        </div>
                    </div>
                    <div className="section__content">
                        <p className="section__lead">
                            А также стандартные и расширенные конверсионные теги можно устанавливать через сторонние системы аналитики (например, <b>Яндекс Тег Менеджер</b>).
                        </p>
                        <div class="tpl_download_wrapper down">
                            <div class="tpl_download">
                                <a href="./materials/setConversionTags.pdf" class="title" target="blank"><svg class="download_icon" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 22.6668L8.024 14.6895L23.976 14.6908L16 22.6668Z" class="fill"/><path d="M20.612 9.33325H11.3333V15.9999H20.612V9.33325Z" class="fill"/><path d="M25.3333 22.6667H6.66667V25.3334H25.3333V22.6667Z" class="fill"/><path d="M12.3333 7V5H19.612V7H12.3333Z" class="stroke" stroke-width="2"/></svg>Инструкция Яндекс ТМ</a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}